/**
 * This component renders a game box component on the game bar
 */

import React from "react";
import { Link } from "react-router-dom";

//process epoc date into format 24 NOV for example,
const processDateDay = (date) => {

  // Convert seconds to milliseconds if input is a number
  const d = new Date(typeof date === "number" ? date * 1000 : date);

  const month = d.toLocaleString("default", { month: "short" }).toUpperCase();
  const day = d.getDate();


  return day + " " + month + " - ";
};

// process "3:30 PM" into 15:30
const processDateTime = (time_text) => {
  const time = time_text.split(" ")[0];
  const ampm = time_text.split(" ")[1];
  const hour = parseInt(time.split(":")[0]);
  const minute = time.split(":")[1];
  if (ampm === "PM") {
    return hour + 12 + ":" + minute;
  } else {
    return hour + ":" + minute;
  }
}
  

const GameBox = ({
  id,
  division,
  date,
  home_team,
  home_score,
  away_team,
  away_score,
  status,
  time_text,
  location,
}) => {
  return (
    <Link
      to={"/game/" + id}
      className="gamebox w-[8rem] min-w-[8rem] xxs:w-[9rem] xxs:min-w-[9rem] sm:w-[10rem] sm:min-w-[10rem] md:w-[14rem] md:min-w-[14.3rem] flex flex-col justify-between items-stretch hover-4"
    >
      <div className=" dark-text px-0.5 gamebox flex flex-col border-l-2 dark:border-dark-3 border-light-3 h-full justify-between items-stretch hover-4 bg-light-1 dark:bg-dark-1">
        {/* Competition league */}
        <p className="text-xxs xxs:text-xs font-light hidden md:flex mx-1 text-darken">
          {division.blip}
        </p>
        <div className="flex flex-row justify-start items-center mx-1">
          <p className="text-xxs font-light text-darken flex-none md:hidden">
            {processDateDay(date)}
          </p>
          <p className="text-xxs font-light text-darken flex-none md:hidden">
            {processDateTime(time_text)}
          </p>
        </div>

        {/* Teams, score, status boxes */}
        <div className="teams-and-score grow h-full w-full flex flex-row justify-between items-stretch">
          {/* Team and score */}
          <div className="left flex flex-col justify-center items-center w-full lg:mr-3 sm:mr-2 xxs:mr-0.5">
            <div className="flex flex-row justify-between items-stretch flex-auto w-full mt-0.5">
              {/* Team 1 */}
              {status === "UPCOMING" ? (
                <div className="flex justify-between items-center sm:mx-1 ml-3">
                  <img
                    src={home_team ? home_team.logo.md : ""}
                    alt={home_team ? home_team.name + "Logo" : ""}
                    title={home_team ? home_team.name : ""}
                    className="team-logo xxs:w-6 xxs:h-6 w-5 h-5 flex"
                  ></img>
                </div>
              ) : (
                <div className="flex justify-between items-center md:mx-1 xxs:ml-0.5 md:ml-3">
                  <img
                    src={home_team ? home_team.logo.md : ""}
                    alt={home_team ? home_team.name + "Logo" : ""}
                    title={home_team ? home_team.name : ""}
                    className="team-logo xxs:w-6 xxs:h-6 w-5 h-5 flex"
                  ></img>
                </div>
              )}
              <p className="highlight team-name text-sm flex mr-1 md:mr-2 justify-between items-center font-medium">
                {home_team ? home_team.blip : ""}
              </p>
              {status === "UPCOMING" ? (
                <p className="highlight team-name text-sm flex sm:mr-0 mr-3 justify-between items-center">
                  {home_score}
                </p>
              ) : (
                <p className="highlight team-name text-sm flex md:mr-0 mr-1 sm:mr-3 justify-between items-center font-medium">
                  {home_score}
                </p>
              )}
            </div>

            <div className="flex flex-row justify-between items-stretch flex-auto w-full mb-0.5">
              {/* Team 2 */}
              {status === "UPCOMING" ? (
                <div className="flex justify-between items-center sm:mx-1 ml-3">
                  <img
                    src={away_team ? away_team.logo.md : ""}
                    alt={away_team ? away_team.name + "Logo" : ""}
                    title={away_team ? away_team.name : ""}
                    className="team-logo xxs:w-6 xxs:h-6 w-5 h-5 flex"
                  ></img>
                </div>
              ) : (
                <div className="flex justify-between items-center md:mx-1 xxs:ml-0.5 md:ml-3">
                  <img
                    src={away_team ? away_team.logo.md : ""}
                    alt={away_team ? away_team.name + "Logo" : ""}
                    title={away_team ? away_team.name : ""}
                    className="team-logo xxs:w-6 xxs:h-6 w-5 h-5 flex"
                  ></img>
                </div>
              )}
              <p className="highlight team-name text-sm flex mr-1 md:mr-2 justify-between items-center font-medium">
                {away_team ? away_team.blip : ""}
              </p>
              {status === "UPCOMING" ? (
                <p className="highlight team-name text-sm flex sm:mr-0 mr-3 justify-between items-center">
                  {away_score}
                </p>
              ) : (
                <p className="highlight team-name text-sm flex md:mr-0 mr-1 sm:mr-3 justify-between items-center font-medium">
                  {away_score}
                </p>
              )}
            </div>
          </div>

          {/* Status */}
          {status === "UPCOMING" ? (
            <div className="team-and-score flex-col justify-center items-center mr-2 hidden sm:flex">
              <p className="team-name text-xxs font-light text-darken">
                {status}
              </p>
            </div>
          ) : (
            <div className="team-and-score flex-col justify-center items-center ml-4 mr-4 hidden md:flex">
              <p className="team-name text-xs font-light text-darken">
                {status}
              </p>
            </div>
          )}
        </div>

        {/* Time and location - allign horizontally first */}
        <div className="time-and-location flex flex-none justify-between items-center mx-1">
          <p className="time text-xxs font-light hidden md:flex text-darken">{time_text}</p>
          <p className="location text-xxs font-light hidden md:flex text-darken text1l">
            {location.length > 20 ? `${location.slice(0, 22)}` : location}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default GameBox;
